import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { SegmentMembersPage } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchMembers(
  segmentId: string,
  pageKey?: string,
): Promise<SegmentMembersPage> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.LIST_SEGMENT_MEMBERS.replace("{segment_id}", segmentId);
  const params = pageKey ? { page_key: pageKey } : undefined;
  const response = await instance.get(url, { params });
  return bonusAdminBody<SegmentMembersPage>(response) ?? { items: [], count: 0, next_page_key: null };
}

export const getSegmentMembersQueryKey = (segmentId: string, pageKey?: string) =>
  ["LIST_SEGMENT_MEMBERS", segmentId, pageKey ?? null] as const;

export const useListSegmentMembers = (segmentId: string, pageKey?: string) => {
  return useQuery<SegmentMembersPage>({
    queryKey: getSegmentMembersQueryKey(segmentId, pageKey),
    queryFn: () => fetchMembers(segmentId, pageKey),
    enabled: Boolean(segmentId),
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
  });
};
